import React from 'react'
import Useletter from '../Useletter'
import Foter from '../Foter'

function Payment() {
  return (
    <div>
      <div className="guide"style={{backgroundColor:"#F9F7FC"}}> <p style={{textAlign: "center",paddingBottom:"20px"}}><span style={{fontSize: "24px", fontFamily:"Alata,sans serif"}}>PAYMENT GUIDELINE</span></p>
      </div>
      <p style={{fontFamily:"Alata,sans serif",fontSize:"14px",textAlign:"left"}}>We aim to provide a safe and secure shopping experience. However, in some instances, we would be needing your <strong>payment details</strong> and <strong>CNIC</strong> to ensure that <br /> your credentials are not being misused and the details are used by the real owner.</p>
      <p style={{fontFamily:"Alata,sans serif",fontSize:"14px",textAlign:"left"}}>Following is the procedure:</p>
   


      <ul style={{  listStylePosition: "inside",textAlign:"left", fontFamily:"Alata,sans serif",fontSize:"14px",}}>

<li style={{ marginBottom: "10px" }}>A picture of your <strong>CNIC (Front and back)</strong> 
</li>
<li style={{ marginBottom: "10px" }}><strong>Card holder's name</strong></li>
<li style={{ marginBottom: "10px" }}><strong>First 6 digits</strong> of the card number</li>
<li style={{ marginBottom: "10px" }}><strong>Last 4 digits</strong> of the card number</li>
<li  style={{ marginBottom: "10px" }}>Picture of your <strong>Credit/Debit card</strong> with the following details only:</li>
</ul>
   
<p style={{fontFamily:"Alata,sans serif",fontSize:"14px",textAlign:"left"}}>We at J. never compromise on the security of the personal details of customers.</p>   
   
<img style={{display:"block",marginLeft:"auto",marginRight:"auto",width:"50%",height:"auto"}} src="https://www.junaidjamshed.com/media/logo/cc2.png" alt=""/>
   
   <Useletter/>
   <Foter/>
   
   
    </div>
  )
}

export default Payment
